module.exports = __webpack_public_path__ + "static/product-procedure-04c2de9207835e59ad126c1be1b36085.png";